import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Welcome extends Component {
  render() {
    return (
      <div className="welcome">
        <h1 className="welcome__title">Wolfgang Ganter</h1>
        <div className="welcome__menu">
          <Link to="/about" className="welcome__menu-link">CV</Link>
          { " / " }
          <Link to="/contact" className="welcome__menu-link">Contact</Link>
        </div>
      </div>
    )
  }
};

export default Welcome;



// WEBPACK FOOTER //
// ./src/components/welcome/index.js